/** Стиль-пак «warm-cream» — свой кусок каталога (WEB-2534: браузер покупателя грузит только пак своей воронки). */
import type { StylePack } from '../stylePack.types';

export const pack: StylePack = {
  id: 'warm-cream',
  shape: {
    radiusCard: 16, radiusOption: 16, radiusButton: 'pill', radiusImage: 8,
    borderWidth: 1, borderTone: 'neutral-warm', selectionMode: 'ring', shadow: 'none',
  },
  density: { optionHeight: 74, optionPadY: 24, optionPadX: 24, gap: 12, contentMaxWidth: 548, screenPadX: 20 },
  type: {
    headingFamily: 'sans', h1Size: 40, h1Weight: 600, h1Tracking: -1,
    qSize: 40, qWeight: 600, qTracking: -1, optionSize: 20, optionWeight: 600,
    headingAlign: 'center', overlineTransform: 'none',
  },
  chrome: { progress: 'segmented', progressLabel: 'center', counter: false, backButton: 'icon-circle', logo: 'left' },
  // WEB-922 (возврат PM 2026-08-03): пак приглушает неактивную кнопку СЕРЫМ,
  // а не брендом. Причина не косметическая: soft-rounded (эталон muted-brand,
  // 12min) и warm-cream — пара, на которой приёмка сравнивает паки, и на этой
  // оси они были неотличимы. Серое приглушение к тому же согласовано с
  // остальными решениями пака: рамка нейтральная (borderTone neutral-warm),
  // выбор — кольцо, а не заливка брендом.
  cta: { placement: 'none', fullWidth: true, height: 56, disabledStyle: 'grey' },
  states: { selected: 'ring', hoverTint: true, transitionMs: 200, screenFadeMs: 0 },
  imagery: {
    optionCard: 'label-overlay-bottom', overlayTone: 'dark', frame: 'rounded',
    promptHint: 'studio photo of a person, warm beige seamless background, soft light',
  },
  // BetterMe: крупный центрированный заголовок и высокие опции начинаются от
  // верха; студийное фото под ними требует ровной вуали, а не нижнего края.
  layout: { alignY: 'top', alignX: 'center', backgroundOverlay: 'scrim-full' },
  // BetterMe: все стадии видны сразу, а вместо процента — карусель лавров
  // (App of the Day ↔ Trustpilot): ожидание закрывается доверием, не цифрой.
  loader: {
    style: 'all-stages', showPercent: false, socialProof: 'laurels',
    answersSummary: false, engagementModals: true,
  },
  // BetterMe: «Reserved price for» крупными цифрами с подписями minutes/
  // seconds под ними, зелёный тикет с персонализированным кодом, цена ЗА ДЕНЬ,
  // тёмная шапка-крышка над рекомендованным тарифом, sticky-хедер с CTA.
  // Блок покупки один: страница ведёт к нему, повторять нечего.
  paywall: {
    timer: 'digits-labeled', promoTicket: 'perforated', priceMode: 'per-day',
    planHighlight: 'cap-header', dimUnselectedPlans: false,
    stickyHeader: true, repeatPurchaseBlock: false,
  },
  // Тёплый пак без золота: премиальность несёт сам бренд (шоколад), деньги —
  // зелёный тикет и юр-бокс автопродления.
  accents: { money: 'success', premium: 'brand' },
};
